<template>
	<div class="home">
		<HeaderBar :title="title"></HeaderBar>
		<div class="center-box-no-footer">
			<van-search v-model="searchValue" show-action placeholder="姓名搜索..." @search="onSearch" clearable>
				<template #action>
					<div @click="onSearch" class="filter-box">
						筛选
						<van-icon name="filter-o" />
					</div>
				</template>
			</van-search>
			<van-list offset="10" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
				class="list-box">
				<div v-for="item in list" :key="item.id" style="width: 100%;">
					<van-swipe-cell>
						<van-cell center is-link @click="Detail(item)" style="width:100%;">
							<template #title>
								<span class="patient-title custom-title">{{ item.bq001001 }}</span>
								<span class="patient-title custom-title" style="font-size: 15px;margin-left: 1rem;">{{
			item.bq001002 }}</span>
								<span class="patient-title custom-title" style="font-size: 15px;margin-left: 0.2rem;">{{
			item.bq001003 == 1 ? '男' : '女' }}</span>
								<span class="patient-title custom-title" style="color: red;"
									v-show="item.bq001042 == 0">已作废</span>

								<!-- <span class="patient-title custom-title">{{item.EmployerName}}</span> -->
							</template>
							<template #label>
								<div class="patient-detail" v-show="true" style="margin-top: 1rem; margin-left: 1rem;">
									<div class="patient-detail-item">治疗日期：{{ (item.bq001040 + '').substring(0, 10) }} 【
										{{ item.extend3 }}岁 】</div>
									<!-- <div class="patient-status active" style="width: 5rem;margin-left: 1rem;">
								<span class="patient-title custom-title" style="font-size: 15px;margin-left: 0.2rem;">{{item.extend3}} 岁</span>
							</div> -->
								</div>
								<div class="patient-detail" style="margin-top: 0.3rem;" v-show="false">
									<div class="patient-detail-item">
										<!-- <van-tag type="success" v-if="item.Bq001_042==1 && item.extend5==''" plain>入组成功</van-tag>
													<van-tag type="danger" v-if="item.Bq001_042==2" plain>未成功入组</van-tag>
													<van-tag type="warning" v-if="item.Bq001_042==1 && item.extend5!=''" plain>数据缺失</van-tag> -->
										<van-tag type="success" v-if="item.Bq400_996 == 3" plain>入组成功</van-tag>
										<van-tag type="danger" v-if="item.Bq400_996 == 1 || item.Bq400_996 == 2"
											plain>未成功入组</van-tag>
										<van-tag type="warning" v-if="item.Bq400_996 == 0" plain>数据采集</van-tag>
									</div>
									<div class="patient-detail-item" style="font-size: 12px;">{{ item.EmployerName }}
									</div>
								</div>
							</template>
						</van-cell>
						<template #right>
							<van-button square text="作废" type="danger" style="height: 100%;"
								v-show="item.bq001042 == 1" @click="changeStatus(item)" />
							<van-button square text="恢复" type="info" style="height: 100%;"
								v-show="item.bq001042 == 0" @click="changeStatus(item)" />
						</template>
					</van-swipe-cell>
				</div>
			</van-list>
		</div>
		<FooterBar></FooterBar>
	</div>
</template>
<script>
export default {
	name: 's400PatientList',
	data() {
		return {
			condition: {
				bq001018: "",
				bq001002: "",
				// bq001042: '1',//只取入组患者，改为取所有
				currentPage: 1,
				pageIndex: 1,
				pageSize: 10,
				recordCount: 0,
				menuid: this.$utils.MenuEnum.patinlist
			},
			title: '患者列表',
			searchUrl: this.$utils.Url.s400 + '/api/S400Bq400/List',
			loading: false,
			finished: false,
			searchValue: "",
			list: [],
			config: JSON.parse(sessionStorage.getItem("config")),
		}

	},
	components: {

	},
	methods: {
		onLoad() {
			let that = this
			that.loading = true
			that.$utils.HttpPost(that.searchUrl, that.condition, function (data) {
				that.condition.pageIndex++
				that.condition.currentPage++
				let dataList = data.data
				dataList.forEach(function (item) {
					that.$utils.CopyKeyInfo(item, item)

					that.list.push(item)
				})
				if (that.list.length >= data.pager.RecordCount) {
					that.finished = true
				}
				that.loading = false


			})
		},
		onSearch() {
			let that = this
			that.condition.currentPage = 1
			that.condition.bq001002 = this.searchValue
			that.finished = false
			that.list = []
			that.onLoad()
		},
		Detail(row) {
			let that = this
			that.$router.push({
				name: "s400PatientDetail",
				params: row
			})
		},
		changeStatus(row) {
			let that = this	
			let args={
				bq001018: row.Bq001_018,
				bq001042: Math.abs( row.bq001042 -1)
			}
			that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq001/UpdateStatus',args, function () {
				that.$dialog({
					message: Math.abs( row.bq001042 -1)==0?'作废成功':'恢复成功',
				})
				row.bq001042 =Math.abs( row.bq001042 -1)
			})
		}
	},
	mounted() {
		// 设置默认MenuId
		this.$http.defaults.headers.common["MenuId"] = "6c8e601a-2f7b-4868-8dd1-aacfa2d8a38b";
	}
}
</script>
<style scoped>
.filter-box {
	font-size: 14px;
	color: #409EFF;
	letter-spacing: 0;
	text-align: left;
	line-height: 14px;
}

.patient-title {
	padding-right: 10px;
	margin-left: 2rem;
}

.patient-detail {
	padding-top: 3px;
	margin-left: 2rem;
}

.patient-detail .patient-detail-item {
	display: inline-block;
	font-size: 14px;
	color: #999999;
	line-height: 14px;
	font-weight: 400;
	padding-left: 15px;
}

.patient-detail .patient-status {
	display: inline-block;
	height: 20px;
	width: 60px;
	line-height: 20px;
	text-align: center;
	font-size: 10px !important;
	color: #FF7B61;
	background: rgba(255, 123, 97, 0.06);
	border: 1px solid #FF7B61;
	border-radius: 4px;
	box-sizing: border-box;
}

.patient-detail .patient-status.active {
	background: rgba(64, 158, 255, 0.06);
	border: 1px solid #409EFF;
	color: #409EFF;
}

::v-deep .van-search .van-cell {
	padding-top: 5px;
	padding-bottom: 5px;
}

::v-deep .van-cell {
	padding-top: 15px;
	padding-bottom: 19px;
}
</style>
